module.exports = function(h, row) {
    let length = row.outlets.length;

    if (length < 1) {
        return <i>No outlets assigned</i>;
    }

    if (length === 1) {
        return row.outlets[0].name;
    }

    return <i>Assigned to {row.outlets.length} outlets</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/pricebook/outlet.jsx